
import { defineComponent } from "vue";
import { nordlyApi, istatics } from "@/services";

export default defineComponent({
  name: "MyAccount",
  data() {
    return {
      username: null,
      mail: null,
      devices: [],
    };
  },
  beforeCreate() {
    nordlyApi
      .accountData("account,devices")
      .then((res: any) => {
        const { account, devices } = res.data;
        this.username = account.username;
        this.mail = account.mail;
        this.devices = devices;

        console.log(devices);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  methods: {
    iconUrl(name: string, color?: string): string {
      return istatics.iconUrl({ name, color });
    },
    logout() {
      nordlyApi.logout().then(() => {
        this.$router.push({ name: "Forms" });
      });
    },
  },
});
